module.exports = __webpack_public_path__ + "img/logo-labuhan-baru.60612bfc.png";